.root {
  flex: 1;
}
